import { render, staticRenderFns } from "./downstream_pipelines.vue?vue&type=template&id=b08a9f7a"
import script from "./downstream_pipelines.vue?vue&type=script&lang=js"
export * from "./downstream_pipelines.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports